<div style="background-color: black; padding-top: 130px;">
    <div class="container">
        <ng-container *ngFor="let year of years">
            <h2  style="color: white;">{{year}}</h2>        
            <app-calendar year="{{year}}"></app-calendar>
        </ng-container>
    </div>
</div>